// Retain the original nodes so cleanup still works after React removes them.
export const attachHeaderListeners = (doc = document, win = window) => {
  const menu = doc.querySelector('.menu');
  const hamburger = doc.querySelector('.hamburger');
  const navigation = doc.querySelector('.navigation');
  const header = doc.querySelector('.dog');
  const handleMenuClick = () => menu?.classList.toggle('open');
  const handleHamburgerClick = () => {
    hamburger?.classList.toggle('active');
    navigation?.classList.toggle('active');
  };
  const handleScroll = () => header?.classList.toggle('fixeds', win.scrollY > 40);

  menu?.addEventListener('click', handleMenuClick);
  hamburger?.addEventListener('click', handleHamburgerClick);
  win.addEventListener('scroll', handleScroll);
  return () => {
    menu?.removeEventListener('click', handleMenuClick);
    hamburger?.removeEventListener('click', handleHamburgerClick);
    win.removeEventListener('scroll', handleScroll);
  };
};
